<template>
  <div id="app-wrap">
    <el-container>
      <el-aside width="224px" class="aside" style="background: #333">
        <div class="top">
          <!-- <img :src="logo" class="logo-img" alt="" /> -->
          
          <span class="logo">花源溪</span>
        </div>
        <el-menu
          class="menu-box"
          background-color="#333"
          text-color="#fff"
          active-text-color="#FF7E90"
          :unique-opened="unique"
          :default-active="current"
        >
          <!-- <div v-for="(menu, index) in menuList1" :key="index">
            <el-submenu
              :index="index + ''"
              v-if="menu.list && menu.list.length"
            >
              <div
                slot="title"
                :class="{
                  'active-nav': current && current.split('-')[0] == index,
                  'menu-title': true,
                }"
              >
                <i class="el-icon-star-on"></i>
                <span>{{ menu.name }}</span>
              </div>
              <el-menu-item-group>
                <el-menu-item
                  v-for="(item, a) in menu.list"
                  :key="a"
                  :index="index + '-' + a"
                  class="menu-title"
                  @click="goPage(item.path, index + '-' + a)"
                  >{{ item.name }}
                </el-menu-item>
              </el-menu-item-group>
            </el-submenu>
            <el-menu-item
              :index="index + ''"
              v-if="!menu.list || !menu.list.length"
              @click="goPage(menu.router, index + '-' + 0)"
            >
              <div
                slot="title"
                :class="{
                  'active-nav': current && current.split('-')[0] == index,
                  'menu-title': true,
                }"
              >
                <i class="el-icon-star-on"></i>
                <span>{{ menu.name }}</span>
              </div>
            </el-menu-item>
          </div> -->
          <div v-for="(menu, index) in menuList" :key="index">
            <el-submenu
              :index="index + ''"
              v-if="menu.list && menu.list.length > 1"
            >
              <div
                slot="title"
                :class="{
                  'active-nav': current && current.split('-')[0] == index,
                  'menu-title': true,
                }"
              >
                <i class="el-icon-star-on"></i>
                <span>{{ menu.name }}</span>
              </div>
              <el-menu-item-group>
                <el-menu-item
                  v-for="(item, a) in menu.list"
                  :key="a"
                  :index="index + '-' + a"
                  class="menu-title"
                  @click="goPage(item.path, index + '-' + a)"
                  >{{ item.name }}
                </el-menu-item>
              </el-menu-item-group>
            </el-submenu>
            <el-menu-item
              :index="index + ''"
              v-if="menu.list && menu.list.length <= 1"
              @click="goPage(menu.list[0].path, index + '-' + 0)"
            >
              <div
                slot="title"
                :class="{
                  'active-nav': current && current.split('-')[0] == index,
                  'menu-title': true,
                }"
              >
                <i class="el-icon-star-on"></i>
                <span>{{ menu.name }}</span>
              </div>
            </el-menu-item>
          </div>
        </el-menu>
      </el-aside>
      <el-container>
        <el-header class="el-head" height="60px">
          <div>
            <div class="username">{{userInfo.username[0]}}</div>
            <div class="logout" @click="logout">退出</div>
          </div>
        </el-header>
        <el-main>
          <div class="detail">
            <keep-alive :include="getKeepAliveList">
              <router-view />
            </keep-alive>
          </div>
        </el-main>
      </el-container>
    </el-container>
    <!-- </el-container> -->
  </div>
</template>

<script type="text/ecmascript-6">
import { mapGetters, mapMutations } from 'vuex';
import { themeColor, logo } from '../config';
export default {
  name: '',
  data() {
    return {
      // logo: '',
      // defaultImg: this.$Public.defaultImg,
      defaultImg: null,
      unique: true,
      menuList: [], // 菜单列表
      themeColor: themeColor,
      logo: logo,
      menuList1: [
        // 开发菜单列表
        {
          mid: '1',
          name: '报修',
          list: [
            {
              index: '1-1',
              name: '报修',
              nav: 'repairManage',
              router: '/repair-manage'
            }
          ]
        },
        {
          mid: '2',
          name: '用户',
          list: [
            {
              index: '2-1',
              name: '用户列表',
              nav: 'userManage',
              router: '/user-manage'
            },
            {
              index: '2-2',
              name: '维修员列表',
              nav: 'maintenance',
              router: '/maintenance'
            }
          ]
        },
        {
          mid: '3',
          name: '小区',
          list: [
            {
              index: '3-1',
              name: '小区管理',
              nav: 'homeManage',
              router: '/home-manage'
            }
          ]
        },
        {
          mid: '4',
          name: '账号管理',
          list: [
            {
              index: '4-1',
              name: '权限组',
              nav: 'powerManage',
              router: '/power-manage'
            },
            {
              index: '4-2',
              name: '账号管理',
              nav: 'accountManage',
              router: '/account-manage'
            }
          ]
        }
      ]
    };
  },
  mounted() {
    this.getBaseInfo();
  },
  computed: {
    ...mapGetters(['menuIndex', 'userInfo', 'keepAliveList']),

    current() {
      let index = this.menuIndex + '';
      if (index !== 'undefined') {
        return index;
      } else {
        return 0;
      }
    },

    getKeepAliveList() {
      return this.keepAliveList;
    }
  },
  watch: {
    // 如果路由有变化，会再次执行该方法
    $route: 'setMenuIndex'
  },
  methods: {
    ...mapMutations(['setMenu', 'clearToken']),
    // 获取导航
    getBaseInfo() {
      this.httpGet(this.$root.managerMenu)
        .then(
          (res) => {
            // this.menuList = res.list;
            this.menuList = res.list.map(item => {
              return {
                ...item.first,
                isFirst: 1,
                list: item.sub
              }
            });
            this.loading = false;
          },
          (err) => {
            this.$message.error(err);
          }
        )
        .catch((e) => {
          this.loading = false;
          console.log(e);
        });
    },
    setMenuIndex() {
      // let currentMenu, firstIndex, secondIndex;
      // for (let i = 0; i <script this.menuList.length; i++) {
      //   currentMenu = this.menuList[i].list.find((item) => {
      //     return item.path === this.$route.path;
      //   });
      //   if (currentMenu) {
      //     firstIndex = i;
      //     secondIndex = currentMenu.order_by;
      //     break;
      //   }
      // }
      // if (currentMenu) {
      //   this.setMenu(firstIndex + "-" + (secondIndex - 1));
      // }
    },
    goPage(val, index) {
      this.setMenu(index);
      this.$router.push(val);
    },
    logout() {
      // 退出账号
      this.httpPost(this.$root.managerLogout).then(
        (res) => {
          this.clearToken();
          this.$router.push('login');
        },
        () => {
          this.$message({
            message: '退出失败',
            type: 'error'
          });
        }
      );
    }
  }
};
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~assets/main.styl';

#app-wrap {
  height: 100%;
}

.top {
  background: #333;
  flex-x(center, center);
  // padding: 0 65px;
  color: white;
  // margin: 15px 0;
  height: 60px;

  .logo {
    word(24, #fff);
    font-weight: 700;
  }

  .logo-img {
    height: 80px;
    width: auto;
    margin-right: 5px;
  }
}

.menu-title {
  font-size: 14px;

  span {
    font-size: 14px;
  }
}

.aside {
  background: #fff;
  // box-shadow: 2px 0px 4px 0px rgba(210, 210, 210, 0.5);
}

h1 {
  color: white;
  font-weight: bold;
  margin: 20px 50px;
}

.el-head {
  background: #333;
  flex-x(flex-end);
  // box-shadow: inset 0px -1px 0px 0px rgba(239, 239, 239, 0.5);
  position: relative;
  z-index: 1;

  >div {
    flex-x(flex-end);

    .username {
      width: 28px;
      height: 28px;
      background: #4876FF;
      flex-x(center);
      border-radius: 14px;
      word(14px, #fff);
      font-weight: 700;
      margin-right: 10px;
    }

    .logout {
      width: 80px;
      height: 24px;
      box-sizing: border-box;
      border: 1px solid #E8E8E8;
      border-radius: 4px;
      flex-x(center);
      word(12px, #666);
      cursor: pointer;
      background: #f6f6f6;

      &:hover {
        background: #f6f6f6;
      }
    }
  }
}

.detail {
  min-width: 800px;
  height: 100%;
  // padding: 0 15px;
  box-sizing: border-box;
}

.icon {
  height: 50px;
  fill: #fff;
  margin: 20px 50px 10px;
}

.el-container {
  height: 100vh;
}

a {
  color: grayE;
}

.el-submenu .el-menu-item {
  opacity: 0.9;
}

.el-menu-item, >>>.el-submenu__title {
  height: 40px;
  line-height: 40px;
}

.el-main {
  background: bk;
  padding: 0;
}

.active-nav {
  color: #FF7E90;

  // background: #EAEFFF;
  // border-radius: 8px;
  // padding-left: 12px;
  // padding-right: 16px;
  // box-sizing: border-box;
  i {
    color: #FF7E90;
  }
}
</style>
